import Actions from '../../../constants/Actions';

export async function setPendingPublish(context, {clientKey, environmentKey, pendingPublish}) {
  console.log('setPendingPublish', clientKey, environmentKey, pendingPublish);
  // update db
  const result = await context.service.update('publish', {environmentKey, pendingPublish, clientKey});
  console.log('Result', result.data);
  // update store
  context.dispatch(Actions.PUBLISH_LOAD_PUBLICATION, result.data);
}



// WEBPACK FOOTER //
// ./src/apps/Publish/actions/PublishActionCreator.js